<div style="padding-top:10px">
  <form novalidate [formGroup]="drillParameterForm" #drillparameter>

    <!-- Begin form layout containeer   -->

    <div class="flex-row flex-align-start flex-auto" style="padding-bottom:10px; padding-top: 20px;">

      <!--  Begin Left Column  layout container Flex Row -->
      <div class="flex-column flex-40">
        <!--<mat-card >-->

        <div class="flex-row flex-align-start flex-auto">

          <div class="flex-column flex-50">
            <div class="flex-row parameter-block form-check">
              <input id="intermediatethreewaterbasedmud" kendoCheckBox class="form-check-input checkbox-parameters" formControlName="IsIntermediateThreeWaterBasedMud" type="checkbox">
              <label class="form-check-label" for="intermediatethreewaterbasedmud">Intermediate 3 Water Based Mud</label>
            </div>

            <div class="flex-row parameter-block form-check">
              <input id="intermediatewaterbasedmud" kendoCheckBox class="form-check-input checkbox-parameters" formControlName="IsIntermediateWaterBasedMud" type="checkbox">
              <label class="form-check-label" for="intermediatewaterbasedmud">Intermediate 2 Water Based Mud</label>
            </div>

            <div class="flex-row parameter-block form-check">
              <input id="spudderrig" kendoCheckBox class="form-check-input checkbox-parameters" formControlName="HasSpudderRig" [disabledControl]="true" type="checkbox">
              <label class="form-check-label" for="spudderrig">Spudder Rig</label>
            </div>

            <div class="flex-row parameter-block form-check">
              <input id="wellheadcellar" kendoCheckBox class="form-check-input checkbox-parameters" formControlName="IsBelowGradeWellheadCellars" [disabledControl]="true" type="checkbox">
              <label class="form-check-label" for="wellheadcellar">Below Grade Wellhead Cellars</label>
            </div>

            <div class="flex-row parameter-block form-check">
              <input id="mudlogging" kendoCheckBox class="form-check-input checkbox-parameters" formControlName="IsMudLogging" type="checkbox">
              <label class="form-check-label" for="mudlogging">Mud Logging</label>
            </div>

            <div class="flex-row parameter-block form-check">
              <input id="rotarysteerable" kendoCheckBox class="form-check-input checkbox-parameters" formControlName="IsRotarySteerable" type="checkbox">
              <label class="form-check-label" for="rotarysteerable">Rotary Steerable</label>
            </div>

            <div class="flex-row parameter-block form-check">
              <input id="wellassignedtoexistingpod" kendoCheckBox class="form-check-input checkbox-parameters" formControlName="PadExists" [disabledControl]="true" type="checkbox">
              <label class="form-check-label" for="wellassignedtoexistingpod">Well Assigned to Existing Pad</label>
            </div>

            <div class="flex-row parameter-block form-check">
              <input id="intermediateoilbasedmud" kendoCheckBox class="form-check-input checkbox-parameters" formControlName="IsIntermediateOilBasedMud" type="checkbox">
              <label class="form-check-label" for="intermediateoilbasedmud">Intermediate 1 Oil Based Mud</label>
            </div>
          </div>

          <div class="flex-column flex-50">

            <div class="form-group">
              <label>Drill Design</label>
              <input type="text" class="k-textbox form-control" readonly value="{{drillObject?.DrillDesign}}">
            </div>
            <div class="form-group" style="width: 100%;">
              <label>Rig</label>
              <input type="text" class="k-textbox form-control" readonly value="{{drillObject?.Rig}}">
            </div>
            <div class="form-group" style="width: 100%;">
              <label>Curve Build</label>
              <kendo-combobox class="form-control" formControlName="CurveBuild"
                [data]="dCurveBuild"
                [textField]="'Description'"
                [valueField]="'CurveBuildId'">
              </kendo-combobox>
            </div>
            <div class="form-group">
              <label>Number of Wells on Pad</label>
              <input type="number" class="k-textbox form-control" readonly value="{{wellsOnPad}}">
            </div>
            <div class="form-group">
              <label>Wells in Drill Group</label>
              <input type="number" class="k-textbox form-control" readonly value="{{wellsInDrillGroup}}">
            </div>
            <div class="form-group">
              <label>Formation</label>
              <input type="text" class="k-textbox form-control" readonly value="{{targetFormation}}">
            </div>
            <div class="form-group">
              <label>Derived Drilled Lateral Length</label>
              <kendo-numerictextbox
                class="form-control"
                [disabled]="true"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat"
                [value]="tempLateralLength">
              </kendo-numerictextbox>
            </div>
            <div class="form-group" style="width: 100%;">
              <label>Cuttings Disposal Method</label>
              <kendo-combobox class="form-control" formControlName="CuttingsDisposalMethod"
                [data]="dCuttingsDisposalMethod"
                [textField]="'Name'"
                [valueField]="'CuttingsDisposalMethodId'">
              </kendo-combobox>
            </div>
          </div>

        </div>

        <!--</mat-card>-->


        <!-- Calculation Overrides Section  -->

        <!--<mat-card>-->

        <!-- Formation Tops Section  - Only show if AssetTeam is PAT-->
        <h6 class="card-title">
          <!--   <input class="" formControlName="FormationTopOverride" (change)="handleFormationTopsOverride($event)" type="checkbox"> -->
          Drilling Parameters
        </h6>
        <div style="padding-bottom:14px">
          <div formArrayName="overrideValues" style="padding-left:10px">
            <div class="flex-row">
              <div class="flex-50">
                <label class="formation-tops-title">Name</label>
              </div>
              <div class="flex-25">
                <label class="formation-tops-title">Value</label>
              </div>
              <div class="flex-25">
                <label class="formation-tops-title">Override Value</label>
              </div>
            </div>

            @for (overrideValue of overrideValues.controls; track overrideValue; let i = $index) {
            <div [formGroupName]="i">
              <!-- The repeated Override template -->
              <div class="flex-row">
                <div class="flex-50">
                  <div class="form-group-element">
                    <input type="text" class=" k-textbox form-control" readonly formControlName="Description">
                  </div>
                </div>
                <div class="flex-25">
                  <div class="form-group-element ">
                    <kendo-numerictextbox formControlName="Value"
                      class="form-control"
                      [disabledControl]="true"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                </div>
                <div class="flex-25">
                  <div class="form-group-element">
                    <kendo-numerictextbox formControlName="OverrideValue"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                </div>
              </div>
              <!-- End of the Override template -->
            </div>
            }
          </div>
        </div>
        <!--</mat-card>-->

        <!-- Coordinates Section  -->

        <h6 class="card-title">Well Coordinates</h6>

        <!--<mat-card>-->
        <!--<mat-card-title style="font-weight:bold;text-align:center;margin-bottom:0px">Plat Coordinates</mat-card-title>-->

        <div class="flex-column" style="padding-bottom:10px">

          <!-- For each Plat Coordinates Row  -->
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px">
            <div class="form-group flex-50">
              <label>SHL/POP X</label>
              <kendo-numerictextbox [readonly]="true" formControlName="SurfaceHoleLocationPointOfPenetrationXCoordinate"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>

            </div>
            <div class="form-group flex-25">
              <label>SHL/POP X Override</label>
              <kendo-numerictextbox formControlName="SurfaceHoleLocationPointOfPenetrationXCoordinateOverride"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>

            </div>
            <div class="form-group flex-25">
              <label>SHL/POP Y</label>
              <kendo-numerictextbox [readonly]="true" formControlName="SurfaceHoleLocationPointOfPenetrationYCoordinate"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>

            </div>
            <div class="form-group flex-25">
              <label>SHL/POP Y Override</label>
              <kendo-numerictextbox formControlName="SurfaceHoleLocationPointOfPenetrationYCoordinateOverride"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>

            </div>
          </div>

          <!-- For each Plat Coordinates  Row  -->

          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px">
            <div class="form-group flex-25">

              <label>FTP X</label>
              <kendo-numerictextbox [readonly]="true" formControlName="FirstTakePointXCoordinate"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>
            </div>
            <div class="form-group flex-25">

              <label>FTP X Override</label>
              <kendo-numerictextbox formControlName="FirstTakePointXCoordinateOverride"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>
            </div>
            <div class="form-group flex-25">
              <label>FTP Y</label>
              <kendo-numerictextbox [readonly]="true" formControlName="FirstTakePointYCoordinate"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>
            </div>
            <div class="form-group flex-25">
              <label>FTP Y Override</label>
              <kendo-numerictextbox formControlName="FirstTakePointYCoordinateOverride"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>
            </div>
          </div>
          <!-- For each Plat Coordinates  Row  -->

          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px">
            <div class="form-group flex-25">
              <label>BHL X</label>
              <kendo-numerictextbox [readonly]="true" formControlName="BottomHoleLocationXCoordinate"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>

            </div>
            <div class="form-group flex-25">
              <label>BHL X Override</label>
              <kendo-numerictextbox formControlName="BottomHoleLocationXCoordinateOverride"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>

            </div>
            <div class="form-group flex-25">
              <label>BHL Y</label>
              <kendo-numerictextbox [readonly]="true" formControlName="BottomHoleLocationYCoordinate"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>
            </div>
            <div class="form-group flex-25">
              <label>BHL Y Override</label>
              <kendo-numerictextbox formControlName="BottomHoleLocationYCoordinateOverride"
                class="form-control"
                [min]="-1000"
                [max]="25000000"
                [step]="5"
                [decimals]="decimalPrecision"
                [spinners]="false"
                [format]="decimalFormat">
              </kendo-numerictextbox>
            </div>
          </div>
        </div>
        <!--</mat-card>-->

      </div>

      <!-- Right Column -->

      <div class="flex-60" style="padding: 0 10px;">
        <div class="float-end">
          <button type="button" kendoButton themeColor="primary" [buttonLoading]="loading" [svgIcon]="icons.refresh" [disabled]="loading" (click)="refreshParameters(true)">Refresh Parameters</button>
        </div>
        <app-project-drilling-phase-step
          [iProjectId]="xProjectId()"
          [iProjectTypeId]="xProjectTypeId()"
          [refresh]="refreshPhaseStepDetail">
        </app-project-drilling-phase-step>

      </div>

    </div>

  </form>

  <!-- End content layout containeer   -->

</div>